import { useMutation } from '@tanstack/react-query';
import { getFormParams } from '../requests';
import type { WithdrawParamsResponse } from '../../model';

type Params = {
  templateId?: string;
};

export const useGetWithdrawParamsMutation = () => {
  const mutation = useMutation<WithdrawParamsResponse, Error, Params>({
    mutationFn: ({ templateId }) => getFormParams(templateId),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
  };
};
